export enum ROLE {
  GENERAL = 'GENERAL',
  PERSONAL = 'PERSONAL',
  EMPLOYEE_COMPANY = 'EMPLOYEE_COMPANY',
  ADMIN_COMPANY = 'ADMIN_COMPANY',
  SUPPORT_COMPANY = 'SUPPORT_COMPANY',
  ADMIN = 'ADMIN',
  GOD = 'GOD',
}

export const MENU_ADMIN = [
  {
    route: '/panel/orders',
    text: 'DASHBOARD',
    icon: 'book',
    tooltip: 'Orders',
  },
  {
    route: '/panel/new-template',
    text: 'NEW TEMPLATE',
    icon: 'chart-pie',
    tooltip: 'New template',
  },
  {
    route: '/panel/automations',
    text: 'AUTOMATIONS',
    icon: 'file',
    tooltip: 'Automations',
  },
  {
    text: 'SETTINGS',
    icon: 'cog',
    tooltip: 'Settings',
    children: [
      {
        route: '/panel/collaborators',
        text: 'COLLABORATORS',
        icon: 'users-group',
        tooltip: 'Collaborators',
      },
      {
        route: '/panel/header-footer',
        text: 'HEADER AND FOOTER',
        icon: 'pen',
        tooltip: 'Header and footer',
      },
      {
        route: '/panel/option-list',
        text: 'OPTION LIST',
        icon: 'clipboard-list',
        tooltip: 'Option list',
      },
      {
        route: '/panel/user-profile',
        text: 'PROFILE',
        icon: 'user',
        tooltip: 'Profile',
      },
    ],
  },
];
export const MENU_GENERAL = [
  {
    route: '/panel/orders',
    text: 'DASHBOARD',
    icon: 'chart-pie',
    tooltip: 'Dashboard',
  },
  {
    route: '/panel/automations',
    text: 'AUTOMATIONS',
    icon: 'file',
    tooltip: 'Automations',
  },
  {
    text: 'SETTINGS',
    icon: 'cog',
    tooltip: 'Settings',
    children: [
      {
        route: '/panel/header-footer',
        text: 'HEADER AND FOOTER',
        icon: 'pen',
        tooltip: 'Header and footer',
      },
      {
        route: '/panel/option-list',
        text: 'OPTION LIST',
        icon: 'clipboard-list',
        tooltip: 'Option list',
      },
      {
        route: '/panel/user-profile',
        text: 'PROFILE',
        icon: 'user',
        tooltip: 'Profile',
      },
    ],
  },
];
